import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import './App.css';

// Components
import Navbar from './components/Navbar/Navbar';
import ToastContainer from './components/Toast/Toast';
import FloatingProfileButton from './components/FloatingButtons/FloatingProfileButton';
import FloatingNotificationButton from './components/FloatingButtons/FloatingNotificationButton';

// Pages
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import CreateMatch from './pages/CreateMatch';
import CreateClasico from './pages/CreateClasico';
import PendingMatches from './pages/PendingMatches';
import ClasicoResults from './pages/ClasicoResults';
import History from './pages/History';
import Translate from './pages/Translate';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Integrations from './pages/Integrations';
import ManualMarkets from './pages/ManualMarkets';
import MarketsCatalog from './pages/MarketsCatalog';
import Documentation from './pages/Documentation';
import Analytics from './pages/Analytics';

function AuthenticatedApp() {
  return (
    <div className="appLayout">
      <Navbar />
      <div className="appContent">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/create" element={<CreateMatch />} />
          <Route path="/clasico" element={<CreateClasico />} />
          <Route path="/pending" element={<PendingMatches />} />
          <Route path="/results" element={<ClasicoResults />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/manual-markets" element={<ManualMarkets />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/history" element={<History />} />
          <Route path="/translate" element={<Translate />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/users" element={<Users />} />
          <Route path="/documentation" element={<Documentation />} />
        </Routes>
      </div>
      <footer className="appFooter">
        All rights reserved — Clasico Analytics &reg; {new Date().getFullYear()}
      </footer>
      <FloatingNotificationButton />
      <FloatingProfileButton />
      <ToastContainer />
    </div>
  );
}

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        {/* Public integrator documentation — accessible without auth */}
        <Route path="/integrations/markets-catalog" element={<MarketsCatalog />} />
        <Route path="/documentation" element={<Documentation />} />
        <Route path="*" element={isAuthenticated ? <AuthenticatedApp /> : <Landing />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
